import React, { useState, useEffect } from "react";
import "./panindia.css";

const jobsData = {
  india: [
    { id: 1, title: "Software Engineer", location: "Bangalore, India", company: "Infosys", badge: "✅ Verified" },
    { id: 2, title: "Data Analyst", location: "Mumbai, India", company: "TCS", badge: "⭐ Featured" },
    { id: 3, title: "Marketing Executive", location: "Delhi, India", company: "Reliance", badge: "✅ Verified" },
  ],
  worldwide: [
    { id: 4, title: "Frontend Developer", location: "New York, USA", company: "Google", badge: "⭐ Featured" },
    { id: 5, title: "UI/UX Designer", location: "London, UK", company: "Amazon", badge: "✅ Verified" },
    { id: 6, title: "Project Manager", location: "Berlin, Germany", company: "Siemens", badge: "✅ Verified" },
  ],
};

export default function JobsSection() {
  const [activeTab, setActiveTab] = useState("india");
  const jobList = activeTab === "india" ? jobsData.india : jobsData.worldwide;

  // Continuous counters
  const [indiaJobs, setIndiaJobs] = useState(1200); // starting number
  const [worldJobs, setWorldJobs] = useState(950);  // starting number

  useEffect(() => {
    const interval = setInterval(() => {
      setIndiaJobs((prev) => prev + 1);
      setWorldJobs((prev) => prev + 1);
    }, 1000); // increase by 1 every 1 second

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="jobs-container">
      {/* Banner Row with Counters */}
      <div className="jobs-banner-row">
        <div className="jobs-banner-col india">
          <div className="banner-icon" style={{ fontSize: "50px" }}>🇮🇳</div>
          <h3>Pan India Opportunities</h3>
          <p>Trusted career opportunities across India with top verified companies.</p>
          <h2 className="job-count bounce">{indiaJobs}+ Jobs</h2>
          <br />
          <a href="/jobSub">
            <button className="explore-btn">Discover India</button>
          </a>
        </div>

        <div className="jobs-banner-col worldwide">
          <div className="banner-icon" style={{ fontSize: "50px" }}>🌎</div>
          <h3>Worldwide Opportunities</h3>
          <p>Build your career globally with verified international companies.</p>
          <h2 className="job-count bounce">{worldJobs}+ Jobs</h2>
          <br />
          <a href="/worldwideJob">
            <button className="explore-btn">Discover Worldwide</button>
          </a>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs">
        <button
          className={`tab-btn ${activeTab === "india" ? "active india" : ""}`}
          onClick={() => setActiveTab("india")}
        >
          🇮🇳 Verified Pan India Jobs
        </button>
        <button
          className={`tab-btn ${activeTab === "worldwide" ? "active world" : ""}`}
          onClick={() => setActiveTab("worldwide")}
        >
          🌍 Trusted Worldwide Careers
        </button>
      </div>

      {/* Job Cards */}
      <div className="jobs-grid">
        {jobList.map((job) => (
          <div key={job.id} className="job-card">
            <div className="job-header">
              <h3>{job.title}</h3>
              <span className={`badge ${job.badge.includes("Featured") ? "featured" : "verified"}`}>
                {job.badge}
              </span>
            </div>
            <p className="company">{job.company}</p>
            <p className="location">{job.location}</p>
            <a href="/form">
              <button className="apply-btn">Apply Securely</button>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
